exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".call-to-action-button[data-v-4bcbef55]{margin-top:1rem;display:inline-block;padding:.6rem 2rem;color:#fff;text-align:center;text-transform:uppercase;font-size:1em;font-weight:600;border:2px solid #fff;border-radius:8px;background-color:transparent}.chatbot-section[data-v-4bcbef55]{background-color:#0aba7e}.section[data-v-4bcbef55]{overflow:hidden}@media screen and (min-width:768px){.text-chatbot[data-v-4bcbef55]{float:right;width:50%}}.title-chatbot[data-v-4bcbef55]{color:#fff}.text-chatbot p[data-v-4bcbef55]{font-size:18px;line-height:2;color:#fff}@media (max-width:913px){.text-chatbot p[data-v-4bcbef55]{margin-bottom:2em}}.img-chatbot[data-v-4bcbef55]{---position:relative;margin-left:0;margin-right:auto;display:block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4bcbef55","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./_source/javascript/components/chatbotsection.vue
// module id = 129
// module chunks = 0